import { Box, Grid } from '@mui/material'
import CheckIcon from '@mui/icons-material/Check';
import ButtonCustom from 'src/shared/components/buttons/ButtonCustom'
import useSavePatient from '../hooks/useSavePatient';
import FormConfirmAccount from './components/FormConfirmAccount';
import { useResetRecoilState } from 'recoil';
import { activeResendCodeState } from '../resendCodeConfirmation/state/atoms';
import { useEffect } from 'react';

const IndexConfirmAccount = () => {
    const { handleClickConfirmAccount, loading } = useSavePatient();
    const resetActiveResendCode = useResetRecoilState(activeResendCodeState);

    useEffect(() => {
        return () => {
            resetActiveResendCode()
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <div className='animate__animated animate__fadeIn'>
            <FormConfirmAccount />
            <Grid container display={"flex"} justifyContent={"center"} pt={2} spacing={2}>
                <Box sx={{
                    padding: '16px 0px 16px 0px'
                }}>
                    <ButtonCustom
                        loading={loading}
                        style={{ marginRight: 15, width: '100%' }}
                        text="CONFIRMAR REGISTRO"
                        color="secondary"
                        icon={<CheckIcon />}
                        onClick={handleClickConfirmAccount}
                    />
                </Box>
            </Grid>
        </div>
    )
}

export default IndexConfirmAccount
